module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (value.threats && value.threats.length) { 
    ; __append("\n<div class=\"title\">")
    ; __append(escapeFn( Glonass.AccidentThreat.titles(value.threats) ))
    ; __append("</div>\n")
    ;  } else if (mode == "native") { 
    ; __append("\n<span></span>\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}